"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStaffEmail = exports.getAvatarUrlWithSize = void 0;
/**
 * Google serves a profile photo at the size its URL ends with (`=s96-c`,
 * `=s256`): the size is rewritten, the options after it (`-c`, `-p`) kept.
 * Any other URL is returned as is.
 */
var getAvatarUrlWithSize = function (avatarUrl, size) {
    return avatarUrl.replace(/=s\d+((?:-[a-z0-9]+)*)$/i, function (_match, options) { return "=s".concat(size).concat(options); });
};
exports.getAvatarUrlWithSize = getAvatarUrlWithSize;
var isStaffEmail = function (email) {
    return Boolean((email === null || email === void 0 ? void 0 : email.endsWith('@ambler.fr')) || (email === null || email === void 0 ? void 0 : email.endsWith('@amblea.fr'))) && !(email === null || email === void 0 ? void 0 : email.includes('+'));
};
exports.isStaffEmail = isStaffEmail;
//# sourceMappingURL=user.js.map